class Menu {
  constructor(el) {}
}

export default Menu;
